<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">ContactType Details</h4>
            <v-simple-table v-if="$route.params.id != 0">
              <tbody>
                <tr>
                  <td>ContactType Name</td>
                  <td>
                    {{ contactTypeModel.name ? contactTypeModel.name : "" }}
                  </td>
                </tr>
                <tr>
                  <td>ContactType Id</td>
                  <td>
                    {{ contactTypeModel.id ? contactTypeModel.id : "" }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-btn
              v-if="$route.params.id == 0"
              color="primary"
              large
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Create a New ContactType</v-btn
            >
            <v-btn
              v-else
              large
              color="primary"
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Edit</v-btn
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ContactType } from "@/models/ContactType";
import { gql } from "apollo-boost";
export default {
  data() {
    return {
      isEdit: false,
      contactTypeModel: new ContactType(),
      me: "",
      search: null,
      crumbs: [
        {
          text: "ContactTypes",
          disabled: false,
          href: "/admin/contactTypes",
        },
        {
          text: "ContactType Details",
          disabled: false,
          href: `/admin/contactTypes/${this.$route.params.id}`,
        },
      ],
    };
  },
  created() {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    contactType: {
      query: gql`
        query ContactType($id: ID!) {
          contactType(id: $id) {
            id
            name
            createdBy
            createdAt
            updatedAt
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id || this.$route.params.id == 0;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
          createdBy: self.me.id,
        };
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading;
      },
      result(response, key) {
        this.isLoading = false;
        this.contactTypeModel.id = this.contactType.id;
        this.contactTypeModel.name = this.contactType.name;
        this.contactTypeModel.createdBy = this.contactType.createdBy;
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
